/**
 * @module app.bdc.reports.sendPdfToMergeCgvCtrl
 */
define(['angular'], function(angular) {


    function SendPdfToMergeCgvCtrl($scope, $uibModalInstance, $window, $sce, commonService) {
        var self = {};

        self.bundle = null;
        self.preview = null;

        self.send = function() {
            $uibModalInstance.close({
                documents: {
                    bundle: self.bundle
                }
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        self.viewer = function (){
            self.preview = self.bundle.split('base64,')[1];
            console.log(self.preview);
            let blob = null;
            blob = commonService.b64toBlob(self.preview, 'application/pdf');
            self.blobURL = $sce.trustAsResourceUrl(URL.createObjectURL(blob) +  '#toolbar=0&navpane=0');
        };

        return self;
    }

    SendPdfToMergeCgvCtrl.$inject = ['$scope', '$uibModalInstance', '$window', '$sce', 'commonService'];

    angular
        .module('app.bdc.reports.sendPdfToMergeCgvCtrl', ['ui.bootstrap.modal'])
        .controller('SendPdfToMergeCgvCtrl', SendPdfToMergeCgvCtrl)
        .directive('fileread2', [
            function() {
                return {
                    scope: {
                        fileread2: '='
                    },
                    link: function(scope, element, attributes) {
                        element.bind('change', function(changeEvent) {
                            var reader = new FileReader();
                            reader.onload = function(loadEvent) {
                                scope.$apply(function() {
                                    scope.fileread2 = loadEvent.target.result;
                                });
                            };
                            reader.readAsDataURL(changeEvent.target.files[0]);
                        });
                    }
                };
            }
        ]);
});
